//get allowed platforms from poc

export const getAllowedPlatforms = async (accessAuthToken: string, pocToken: string): Promise<string[]> => {
  try {
    //add poc token to the body
    const requestBody = {
      pocToken: pocToken,
    };
    const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/allowed_platforms`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessAuthToken}`,
      },
      body: JSON.stringify(requestBody),
      credentials: "include",
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch allowed platforms: ${response.statusText}`);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching allowed platforms:", error);
    // As a fallback in case of error, to avoid breaking the UI
    return ["MFL", "Sleeper", "Flea_flicker"];
  }
};
